import Root from './input.svelte';

export {
  //
  Root as Input,
  Root
};
